module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yUY3zI/media/FC-9781035807789.jpg?1692049824075",
      "alt": "This image is the cover for the book A Nod’s As Good As A Wink …"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Nod’s As Good As A Wink …\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It’s the early, swinging 70s in London, and Ollie is riding the wave. There’s a day-job and rent to pay but that never gets in the way of the pubs and women. What does get in the way is the ever-present black dog of depression: a depression that clouds his daily life with feelings of guilt, more or less about everything. And if that wasn’t bad enough, add a stalker to the mix, no doubt the result of something else he’s guilty of, and Ollie knows he’s in real trouble. So he needs to get his head right, but it’s not until his shrink, Kline, hypnotises him that Ollie remembers dark events in his early years and he is able to confront his demons, inside and out. ‘A Nod’s As Good As A Wink …’ is Ollie’s tale of discovery, full of pain and humour, as he goes from relationship to relationship looking for his place in the sun.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dennis Sullivan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dennis left England in 1974 and emigrated to Toronto, Canada. It was a good move; he started a family, and found out that his talents were no more valuable in Canada than they were in England. Like a lot of Londoners growing up in the 50s and 60s he did many jobs and was fortunate to go off to Spain in the late sixties to look after happy holiday-makers when he didn’t speak the language nor know anything about the resort. He continued with that responsible and mature attitude in Canada and has prospered ever since. In a way Dennis’s novel is a celebration of survival.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0